import {columnProps} from '../util/default-props'

export default {
  name: 'SyTableColumn',
  props: columnProps
}
